import { prefixedTestId } from '@/utils/dataTestId';

export const FROM_PAGES = ['main'];

export const FROM_PAGE_ROUTES = {
  main: '/',
};

export const MULTI_ASSET_COLUMN_IDS = [1, 2, 3, 4, 5];

export const REGIME_SELECTORS_TEST_ID = 'main-period-regime-selectors';
export const MAX_REGIME_BOUNDARIES = 4;
export const regimeBoundaryThumbName = (index) => `boundary-${index + 1}`;

const REGIME_BOUNDARY_SUFFIXES = Array.from({ length: MAX_REGIME_BOUNDARIES }, (_, index) => {
  const name = regimeBoundaryThumbName(index);
  return [`regime-selectors-${name}-thumb`, `regime-selectors-${name}-input:range`];
}).flat();

export const TID_SUFFIX_GROUPS = [
  {
    fromPages: ['main'],
    prefixes: ['main-nav'],
    suffixes: [
      'logo-btn',
      'menu-btn',
      'home-btn',
      'logout-btn',
      'login-btn',
    ],
  },
  {
    fromPages: ['main'],
    prefixes: ['main-footer'],
    suffixes: ['universa-analytics-btn', 'privacy-policy-btn'],
  },
  {
    fromPages: ['main'],
    prefixes: ['main-parity'],
    suffixes: ['js-btn', 'py-btn'],
  },
  {
    fromPages: ['main'],
    prefixes: ['main-period'],
    suffixes: [
      'from-year-input:range',
      'to-year-input:range',
      'regime-count-input:number',
      'regime-selectors-input:range',
      ...REGIME_BOUNDARY_SUFFIXES,
    ],
  },
  {
    fromPages: ['main'],
    prefixes: ['main-period-mode'],
    suffixes: ['singleasset-btn', 'differentasset-btn'],
  },
  {
    fromPages: ['main'],
    prefixes: ['main-single-type', 'main-multi-type'],
    suffixes: ['normal-btn', 'reshuffle-btn', 'nocrash-btn'],
  },
  {
    fromPages: ['main'],
    prefixes: ['main-single'],
    suffixes: ['percentile-1-select', 'percentile-2-select'],
  },
  {
    fromPages: ['main'],
    prefixes: ['main-second-asset'],
    suffixes: ['select'],
  },
  {
    fromPages: ['main'],
    prefixes: ['main-cross-asset'],
    suffixes: [
      'insurance-alloc-input:range',
      'alloc-input:range',
      'alloc-lock-toggle-btn',
    ],
  },
  {
    fromPages: ['main'],
    prefixes: ['main-returns'],
    suffixes: ['first-asset-select'],
  },
  {
    fromPages: ['main'],
    prefixes: ['main-charts'],
    suffixes: ['zoom-reset-btn'],
  },
  {
    fromPages: ['main'],
    prefixes: ['main-multi'],
    suffixes: [
      'pin-toggle-btn',
      'reset-btn',
      'alloc-lock-toggle-btn',
      'percentile-lock-toggle-btn',
      'add-asset-btn',
    ],
  },
];

function emptyPageIdSets() {
  return Object.fromEntries(FROM_PAGES.map((page) => [page, new Set()]));
}

function addPrefixedSuffixes(pageIds, fromPage, prefix, suffixes) {
  if (!pageIds[fromPage]) return;
  suffixes.forEach((suffix) => {
    const id = prefixedTestId(prefix, suffix);
    if (id) pageIds[fromPage].add(id);
  });
}

function expandTidSuffixGroups(pageIds) {
  TID_SUFFIX_GROUPS.forEach((group) => {
    group.fromPages.forEach((fromPage) => {
      group.prefixes.forEach((prefix) => {
        addPrefixedSuffixes(pageIds, fromPage, prefix, group.suffixes);
      });
    });
  });
}

function expandMultiAssetColumnIds(pageIds) {
  const suffixes = [
    'second-asset-select',
    'insurance-alloc-input:range',
    'alloc-input:range',
    'percentile-1-select',
    'percentile-2-select',
  ];
  MULTI_ASSET_COLUMN_IDS.forEach((columnId) => {
    const prefix = `main-multi-asset-${columnId}`;
    addPrefixedSuffixes(pageIds, 'main', prefix, suffixes);
  });
}

export function buildCatalogTestIdsByFromPage() {
  const pageIds = emptyPageIdSets();
  expandTidSuffixGroups(pageIds);
  expandMultiAssetColumnIds(pageIds);
  return pageIds;
}

export function getFromPagesForTestId(testId) {
  if (!testId || typeof testId !== 'string') return [];
  if (testId.startsWith('chat-overlay-')) return [];
  if (testId.startsWith('main-')) return ['main'];
  return [];
}

export function testIdBelongsToFromPage(testId, fromPage) {
  if (!fromPage || !testId) return false;
  return getFromPagesForTestId(testId).includes(fromPage);
}

export function extractLiteralTidSuffixes(source) {
  const suffixes = new Set();
  const patterns = [/tid\('([^']+)'\)/g, /tid\("([^"]+)"\)/g];
  patterns.forEach((pattern) => {
    let match;
    while ((match = pattern.exec(source)) !== null) {
      const value = match[1].trim();
      if (value && !value.includes('${')) suffixes.add(value);
    }
  });
  return [...suffixes];
}
